import {Component, ComponentFactoryResolver, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {IPageableContent} from '../shared/pageable-content';
import {RankingModel} from './ranking.model';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {DialogService} from '../dialog/dialog.service';
import {UserService} from '@core/ecv-http-services/services/user.service';
import {AlertService} from '@widgets/alert/alert.service';
import {RankingSearchComponent} from './ranking-search/ranking-search.component';

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html'
})

export class RankingComponent {
  @ViewChild(RankingSearchComponent) searchComponent: RankingSearchComponent;
  allExperts: IPageableContent<RankingModel>;
  experts: RankingModel[];
  pageNumber = 0;
  pageSize = 20;
  modalVisible = false;
  searchByText = false;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private dialogService: DialogService,
              private userService: UserService,
              private alertService: AlertService,
              private translateService: TranslateService,
              private spinnerService: Ng4LoadingSpinnerService) {
  }

  loadRanking(pageNumber: number, newQuery: boolean, searchByText: boolean, increment: number): void {
    this.searchByText = searchByText;
    if (increment) {
      const index = pageNumber * this.pageSize;
      this.experts = this.allExperts.content.slice(index, index + this.pageSize);
      this.pageNumber += increment;
      return;
    }
    const api = this.searchComponent.loadData(pageNumber, this.pageSize, newQuery, searchByText);
    if (!api) {
      return;
    }
    this.spinnerService.show();
    api.subscribe(
      response => {
        this.pageNumber = 0;
        this.allExperts = response;
        this.experts = response.content.slice(0, this.pageSize);
        this.spinnerService.hide();
      }, requestError => {
        this.spinnerService.hide();
      }
    );
  }

  movePages(increment: number) {
    const newPageNumber = this.pageNumber + increment;
    this.loadRanking(newPageNumber, false, this.searchByText, increment);
  }

  searchForExpertCV(userId: number) {
    if (this.modalVisible) {
      return;
    }
    this.modalVisible = true;
    this.userService.getCvs(userId).subscribe(
      response => {
        if (response && response.length > 0) {
          this.dialogService.openRankingCVModal(response, this);
        } else {
          this.modalVisible = false;
          this.translateService.get('ERROR.5019', {}).subscribe((res: string) => {
            this.alertService.error(res);
          });
        }
      });
  }

  onModalClose() {
    this.modalVisible = false;
  }

  redirectToProfile(referenceNumber: string) {
    window.open('/ecv/step-1/' + referenceNumber, '_blank');
  }

  getTotalPages(): number {
    const totalPages = (this.allExperts.totalElements / this.pageSize) | 0;
    return (this.allExperts.totalElements % this.pageSize !== 0) ? totalPages + 1 : totalPages;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ranking/ranking.component.ts